// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderLinesListStyles } from "@ces/Overrides/Components/CartLinesList";
import { xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

orderLinesListStyles.header = {
    wrapper: {
        css: css`
            border-bottom: none;
        `,
    },
};

orderLinesListStyles.cardExpanded = {
    gridContainer: {
        container: {
            css: css`
                ${xScreen("gt", "sm")} {
                    &:last-child {
                        border: none;
                    }
                }
            `,
        },
    },
    extendedUnitNetPriceHeadingAndText: {
        extendedStyles: {
            text: {
                css: css`
                    ${({ editableQty }: any) => (editableQty ? "padding-top: 6px;" : "padding-top: 0;")}
                    ${xScreen("lte", "md")} {
                        padding-top: 0px;
                    }
                `,
            },
            heading: {
                css: css`
                    ${({ editableQty }: any) => (editableQty ? "margin-bottom: 7px;" : "margin-bottom: 4px;")}
                `,
            },
        },
    },
    productPrice: {
        priceWrapper: {
            css: css`
                ${({ editableQty }: any) => (editableQty ? "padding-top: 6px;" : "padding-top: 0;")}
                ${xScreen("lte", "md")} {
                    padding-top: 0px;
                }
            `,
        },
    },
};
